var map = {
	"./t2.png": "bAXO",
	"./t2_h.png": "nddX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0D4B";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab ^\.\/t2.*\.png$
// module id = 0D4B
// module chunks = 1